import { render, staticRenderFns } from "./ImageButtonDelete.vue?vue&type=template&id=3556776c&scoped=true&"
import script from "./ImageButtonDelete.vue?vue&type=script&lang=js&"
export * from "./ImageButtonDelete.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sass/style_custom.scss?vue&type=style&index=0&id=3556776c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3556776c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3556776c')) {
      api.createRecord('3556776c', component.options)
    } else {
      api.reload('3556776c', component.options)
    }
    module.hot.accept("./ImageButtonDelete.vue?vue&type=template&id=3556776c&scoped=true&", function () {
      api.rerender('3556776c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Buttons/ImageButtonDelete.vue"
export default component.exports